import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { CredentialsProvider } from "auth/modules/sagas/CredentialsProvider";
import { addNotification, loading } from "layouts/AppLayout/modules";

import { FETCH_CMS_TOKENS, FetchCMSTokensAction, fetchCMSTokensEnd } from "../actions/FetchCMSTokens";

export function* fetchCMSTokens(action: FetchCMSTokensAction) {
    const { appId, credentials } = action.payload;

    try {
        const api = new ApiGatewayApi(new CredentialsProvider(credentials));
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.getCMSTokens(appId);
        yield put(fetchCMSTokensEnd(appId, undefined, result.tokens));
    } catch (e) {
        yield put(fetchCMSTokensEnd(appId, e, undefined));
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchFetchCMSTokens() {
    yield takeEvery(FETCH_CMS_TOKENS, fetchCMSTokens);
}
